export const ar = {
  login: {
    title: "تسجيل الدخول إلى OrderHub",
    emailLabel: "عنوان البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    passwordLabel: "كلمة المرور",
    signIn: "تسجيل الدخول",
    signingIn: "جارٍ تسجيل الدخول...",
    invalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
    forgotPassword: "هل نسيت كلمة المرور؟",
    noAccount: "ليس لديك حساب؟",
    signUp: "إنشاء حساب",
  },
  signup: {
    fullNameLabel: "الاسم الكامل",
    fullNamePlaceholder: "ادخل اسم المستخدم",
    nameRequired: "الاسم مطلوب",
    emailLabel: "عنوان البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    emailInvalid: "يرجى إدخال عنوان بريد إلكتروني صحيح",
    passwordLabel: "كلمة المرور",
    passwordInvalid: "كلمة المرور لا تستوفي جميع المتطلبات",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
    createAccount: "إنشاء حساب",
    creatingAccount: "جارٍ إنشاء الحساب...",
    userExists: "هذا البريد الإلكتروني مرتبط بحساب بالفعل.",
    loginInstead: "تسجيل الدخول بدلاً من ذلك؟",
    rateLimited: "محاولات إنشاء حساب كثيرة جدًا. حاول مرة أخرى لاحقًا.",
    signupFailed: "فشل إنشاء الحساب",
  },
  forgotPassword: {
    title: "هل نسيت كلمة المرور؟",
    subtitle: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
    emailLabel: "عنوان البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    emailRequired: "يرجى إدخال عنوان بريدك الإلكتروني.",
    sendResetLink: "إرسال رابط إعادة التعيين",
    sending: "جارٍ الإرسال...",
    backToLogin: "العودة لتسجيل الدخول",
    rememberPassword: "تتذكر كلمة المرور؟",
    checkInboxTitle: "تحقق من بريدك الوارد",
    checkInboxBody: "إذا كان هناك حساب مسجل بهذا البريد الإلكتروني، فإن رابط إعادة تعيين كلمة المرور في طريقه إليك. يرجى التحقق من بريدك الوارد ومجلد الرسائل غير المرغوب فيها.",
    linkExpiry: "سينتهي الرابط خلال ساعة واحدة.",
    rateLimited: "طلبات كثيرة جدًا. حاول مرة أخرى لاحقًا.",
    accountInactive: "حسابك غير نشط. يرجى التواصل مع المسؤول.",
  },
  resetPassword: {
    title: "تعيين كلمة مرور جديدة",
    subtitle: "اختر كلمة مرور قوية لحسابك.",
    newPasswordLabel: "كلمة المرور الجديدة",
    confirmPasswordLabel: "تأكيد كلمة المرور الجديدة",
    submitButton: "إعادة تعيين كلمة المرور",
    submitting: "جارٍ إعادة تعيين كلمة المرور...",
    successTitle: "تم إعادة تعيين كلمة المرور بنجاح",
    successBody: "تم تحديث كلمة المرور الخاصة بك. تم تسجيل الخروج من جميع الجلسات النشطة الأخرى لأمانك.",
    signInWithNewPassword: "تسجيل الدخول بكلمة المرور الجديدة",
    invalidLinkTitle: "رابط غير صالح أو منتهي الصلاحية",
    invalidLinkBody: "رابط إعادة تعيين كلمة المرور هذا غير صالح أو انتهت صلاحيته. يرجى طلب رابط جديد.",
    requestNewLink: "طلب رابط جديد",
    failed: "فشل إعادة تعيين كلمة المرور. قد يكون الرابط قد انتهت صلاحيته.",
    passwordInvalid: "كلمة المرور لا تستوفي جميع المتطلبات",
    passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
  },
  invitation: {
    title: "لقد تمت دعوتك!",
    subtitle: "انضم إلى {{orgName}} على OrderHub",
    teamAssigned: "تم تعيين فريق",
    emailLabel: "البريد الإلكتروني",
    fullNameLabel: "الاسم الكامل",
    fullNamePlaceholder: "أدخل اسمك الكامل",
    passwordLabel: "كلمة المرور",
    passwordPlaceholder: "8 أحرف على الأقل",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أكّد كلمة المرور",
    submitButton: "إنشاء حساب والانضمام",
    submitting: "جارٍ إنشاء الحساب...",
    nameRequired: "الاسم مطلوب",
    passwordTooShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
    createFailed: "فشل إنشاء الحساب",
    somethingWrong: "حدث خطأ ما. حاول مرة أخرى.",
    errorTitle: "خطأ في الدعوة",
    noInvitationId: "لم يتم توفير معرف الدعوة.",
    invalidInvitation: "هذه الدعوة غير صالحة أو منتهية الصلاحية أو تم استخدامها بالفعل.",
    goToSignIn: "الذهاب لتسجيل الدخول",
  },
  oauth: {
    googleSignup: "الاشتراك باستخدام Google",
    googleLogin: "المتابعة باستخدام Google",
    googleFailed: "فشل تسجيل الدخول عبر Google. حاول مرة أخرى.",
  },
  verification: {
    bannerText: "يرجى التحقق من عنوان بريدك الإلكتروني لربط متاجر Shopify وإنشاء شروط التشغيل.",
    resendButton: "إعادة إرسال بريد التحقق",
    sending: "جارٍ الإرسال...",
    rateLimited: "يرجى الانتظار قبل إعادة المحاولة",
    sent: "تم إرسال بريد التحقق!",
    failed: "فشل إعادة إرسال بريد التحقق. حاول مرة أخرى.",
  },
  passwordRequirements: {
    title: "متطلبات كلمة المرور",
    length: "8 أحرف على الأقل",
    upper: "حرف كبير واحد",
    lower: "حرف صغير واحد",
    number: "رقم واحد",
  },
  brandPanel: {
    headingLine1: "إدارة",
    headingLine2: "طلبات Shopify",
    headingLine3: "بكفاءة",
    description: "بسّط إدارة طلباتك باستخدام المحفزات الذكية والتتبع الفوري والتعاون السلس بين الفريق.",
    features: {
      trackingTitle: "تتبع الطلبات في الوقت الفعلي",
      trackingDesc: "راقب كل طلب وهو يحدث",
      triggersTitle: "قواعد زناد ذكية",
      triggersDesc: "أتمت الإجراءات بناءً على أحداث الطلبات",
      collaborationTitle: "تعاون الفريق",
      collaborationDesc: "عيّن واطلب وحل معًا",
    },
  },
  authPage: {
    welcomeBack: "مرحبًا بعودتك",
    welcomeBackSubtitle: "سجّل الدخول إلى حسابك في OrderHub",
    createAccount: "أنشئ حسابك",
    createAccountSubtitle: "ابدأ مع OrderHub مجانًا",
    loginTab: "تسجيل الدخول",
    signupTab: "إنشاء حساب",
    passwordResetSuccess: "تمت إعادة تعيين كلمة المرور بنجاح. يرجى تسجيل الدخول بكلمة المرور الجديدة.",
  },
  sessionExpired: {
    title: "انتهت الجلسة",
    description: "انتهت جلستك بسبب {{minutes}} دقيقة من عدم النشاط.",
    loggingOut: "جارٍ تسجيل الخروج...",
    logOut: "تسجيل الخروج",
  },
  accountLocked: {
    title: "الحساب مقفل",
    description: "مساحة عملك لديها مشكلة في الفوترة. يرجى الاتصال بمسؤول النظام لاستعادة الوصول.",
    contactAdmin: "اتصل بمسؤول النظام",
    signOut: "تسجيل الخروج",
  },
  shopifyWelcome: {
    title: "مرحباً بك في OrderHub",
    subtitle: "أنشئ حسابك للبدء",
    signupTab: "إنشاء حساب",
    loginTab: "تسجيل الدخول",
    quickSetupBadge: "إعداد سريع — دقيقتان",
    panelHeadingLine1: "أنت على بعد",
    panelHeadingHighlight: "3 خطوات سهلة",
    panelHeadingLine3: "فقط",
    panelDescription:
      "انضم إلى آلاف تجار Shopify الذين يوفرون ساعات كل أسبوع مع إدارة طلبات أذكى.",
    stepIndicatorLabel: "الخطوة 1 من 3",
    stepIndicatorContext: "إنشاء حساب",
    steps: {
      signupTitle: "أنشئ حسابك",
      signupDesc: "سجل باستخدام Google أو البريد الإلكتروني في ثوانٍ",
      connectTitle: "اربط متجر Shopify",
      connectDesc: "ربط آمن لمتجرك بنقرة واحدة",
      teamTitle: "ادعُ فريقك",
      teamDesc: "أضف زملاءك للتعاون في الطلبات",
    },
    benefits: {
      freeTrial: "تجربة مجانية 14 يوماً",
      noCreditCard: "لا حاجة لبطاقة ائتمان",
      cancelAnytime: "ألغِ في أي وقت",
    },
    poweredBy: "مدعوم بواسطة",
  },
} as const;
